import type { PortDistanceSource } from '@felix/domain';
import { useTranslation } from 'react-i18next';
import { StatusBadge, type StatusTone } from '../../StatusBadge.js';

const TONE: Record<PortDistanceSource | 'estimate', StatusTone> = {
  manual: 'success',
  imported: 'info',
  computed: 'neutral',
  estimate: 'warning',
};

/**
 * Mesafenin kaynağı (ADR 0048 §3): elle, içe aktarılan, saklanan hesap ya da o an tahmin
 * (saklanmamış). Renk tek başına anlam taşımaz; metin her zaman yazılır.
 */
export function SourceBadge({
  source,
  stored,
}: {
  source: PortDistanceSource | null;
  stored: boolean;
}) {
  const { t } = useTranslation();
  if (!source) return <>—</>;
  const key = source === 'computed' && !stored ? 'estimate' : source;
  return <StatusBadge tone={TONE[key]}>{t(`ports.source.${key}`)}</StatusBadge>;
}
